import { all } from "redux-saga/effects";
import {
  listenGetToken,
  listenSetSessionToken,
  listenSetToken
} from "./auth.sagas";
import { listengetRoles } from "./authr.sagas";
import { listengetBookingStatus } from "./booking.sagas";
import {
  listenGetConstants,
  listenGetCountries,
  listenGetCurrencies,
  listenGetHotelFloorAssign,
  listenGetHotelRoomCategory,
  listenGetLanguages,
  listenGetPms,
  listenGetStates
} from "./constants.sagas";
import {
  fetchAddAssignRoom,
  fetchAddHotelFloor,
  fetchEditFloorAssignment,
  fetchEditHotelFloor,
  fetchGetHotelFloorDetails,
  fetchHotelFloorNameList,
  fetchHotelFloors
} from "./floor.sagas";
import {
  fetchAddHotelTags, fetchHotelConfiguration, fetchHotelDetail,
  fetchHotelTags,
  fetchRemoveHotelTag,
  fetchSearchedHotelTags,
  fetchUpdateHotelDetails
} from "./hotelDetail.sagas";
import {
  listenGetHotel, listenGetHotelByHotelGroups,
  listenGetHotelGroupList, listenHotelManagementResetState
} from "./hotelmanagement.sagas";
import {
  createHotelRoom,
  fetchGetRoomDetails,
  listenfetchRoomList,
  listenupdateRoom
} from "./hotelRoom.sagas";
import {
  fetchHotelLanguageSettings,
  fetchStoreHotelLanguageSettings,
  listenGetLanguage
} from "./LanguageSettings.sagas";
import {
  listenActivateUser, listenChangePassword,
  listenconfirmPassword,
  listenDeactivateUser,
  listenforgotPassword,
  listenLogin,
  listenLogOut,
  listenResetPassword,
  listenSetPassword
} from "./login.sagas";
import {
  listenaddOffer,
  listenEditOffer,
  listeneditSearchOffers,
  listenGetOffer,
  listenGetOfferById
} from "./offers.sagas";
import {
  listenGetExportedFile,
  listenGetHotelFromHotelGroup,
  listenGetReports
} from "./report.sagas";
import {
  addRoomCategories,
  editRoomCategory,
  fetchPMSRoomTypes,
  fetchRoomCategories,
  fetchRoomCategoryById,
  listensortCategories
} from "./roomCategories.sagas";
import {
  fetchCreateHotelSeasonPricing,
  fetchHotelSeasonPricing,
  fetchHotelSeasonPricingDetail,
  fetchUpdateHotelSeasonPricing
} from "./seasonPricing.sagas";
import {
  listenaddService,
  listeneditSearchService,
  listeneditService, listenEmailService, listenGetDealType, listenGetEmailService, listengetServices,
  listenServiceById
} from "./service.sagas";
import {
  fetchSaveTranslation,
  fetchTranslationTabs
} from "./translation.sagas";
import {
  listenAddUser,
  listengetUserById,
  listengetUserProfile,
  listengetUsers,
  listenUpdateUser,
  listenupdateUserProfile
} from "./userManagement.sagas";

export default function* rootSaga() {
  yield all([
    listenGetLanguages(),
    listenGetPms(),
    listenGetHotelRoomCategory(),
    listenGetHotelByHotelGroups(),
    listenGetHotelFloorAssign(),
    listenGetConstants(),
    listenGetHotelGroupList(),
    listenLogin(),
    listenGetToken(),
    listenSetToken(),
    fetchHotelDetail(),
    fetchHotelTags(),
    fetchAddHotelTags(),
    fetchRemoveHotelTag(),
    fetchSearchedHotelTags(),
    fetchUpdateHotelDetails(),
    fetchAddHotelFloor(),
    fetchGetHotelFloorDetails(),
    fetchEditHotelFloor(),
    fetchRoomCategories(),
    fetchPMSRoomTypes(),
    addRoomCategories(),
    fetchRoomCategoryById(),
    editRoomCategory(),
    fetchHotelFloors(),
    fetchHotelLanguageSettings(),
    fetchStoreHotelLanguageSettings(),
    createHotelRoom(),
    fetchGetRoomDetails(),
    listengetServices(),
    listeneditSearchService(),
    listenaddService(),
    listenGetOffer(),
    listenGetOfferById(),
    listenaddOffer(),
    listeneditSearchOffers(),
    listenServiceById(),
    listeneditService(),
    listenEditOffer(),
    listensortCategories(),
    listenfetchRoomList(),
    fetchHotelSeasonPricingDetail(),
    fetchCreateHotelSeasonPricing(),
    fetchUpdateHotelSeasonPricing(),
    fetchHotelSeasonPricing(),
    listenupdateRoom(),
    fetchAddAssignRoom(),
    fetchHotelFloorNameList(),
    fetchEditFloorAssignment(),
    fetchTranslationTabs(),
    fetchSaveTranslation(),
    listenGetCurrencies(),
    listenGetLanguage(),
    listenLogOut(),
    listenforgotPassword(),
    listenconfirmPassword(),
    listengetUsers(),
    listenAddUser(),
    listenUpdateUser(),
    listengetUserProfile(),
    listenupdateUserProfile(),
    listenResetPassword(),
    listenSetPassword(),
    listengetUserById(),
    listenSetSessionToken(),
    listenGetDealType(),

    //
    listenGetCountries(),
    listenGetStates(),
    listenGetReports(),
    listenGetExportedFile(),
    listenDeactivateUser(),
    listenChangePassword(),
    listenGetHotelFromHotelGroup(),
    listengetRoles(),
    listenGetHotel(),
    listenHotelManagementResetState(),
    listenEmailService(),
    listenGetEmailService(),
    listenActivateUser(),
    listengetBookingStatus(),
    fetchHotelConfiguration()
  ]);
}
